import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { commonModules } from 'src/app/app.config';
import { LocationTemplatesDataSource } from 'src/app/datasources/location-templates-datasource';
import { LocationTemplate } from 'src/app/planvue-api';
import { PagedTableComponent } from '../base-classes/paged-table';
import { ConfirmationDialogComponent } from '../dialog/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-location-template-table',
  templateUrl: './location-template-table.component.html',
  styleUrl: './location-template-table.component.scss',
  standalone: true, 
  imports: [...commonModules]
})
export class LocationTemplateTableComponent extends PagedTableComponent<LocationTemplate, LocationTemplatesDataSource> implements OnInit {
  @Output()
  public readonly templateDeleted = new EventEmitter<LocationTemplate>();
  route = inject(ActivatedRoute);
  dialog = inject(MatDialog);

  ngOnInit(): void {
    this.columns = this.datasource.columns;
    this.datasource.loadItems()
  }

  deleteTemplate(template: LocationTemplate): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      minWidth: "400px",
      data:  {
        title: `Delete Template ${template.filename}?`,
        message: "",
        confirmText: "Delete",
        cancelText: "Cancel",
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
          this.templateDeleted.emit(template);
      }
    });
  }

  getNoDataMessage():string {
    return 'No Templates found.';
  }
}
